// Add key/value in sessionStorage
const setItem = (key: string, value: string) => {
  sessionStorage.setItem(key, value);
};

// Get a value from sessionStorage
const getItem = (key: string) => sessionStorage.getItem(key);

// Remove item by its key
const removeItem = (key: string) => {
  sessionStorage.removeItem(key);
};

export default {
  setItem,
  getItem,
  removeItem,
};
